import React from 'react';
import {Icon, Modal, Profile, Text} from '@/ui-kits';
import {Doctor} from '@/interface';
import {formatName} from '@/utils/common_functions';

// Doctor Profile Modal Component
interface DoctorProfileModalProps {
  doctor: Doctor;
  isOpen: boolean;
  onClose: () => void;
}

export const DoctorProfileModal: React.FC<DoctorProfileModalProps> = ({
  doctor,
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className="rounded-2xl w-full max-w-sm shadow-2xl flex flex-col">
      {/* Close Button */}
      <button onClick={onClose} className="absolute top-4 right-4 outline-none">
        <Icon type="close" className="size-6" />
      </button>

      {/* Doctor Image */}
      <div className="bg-sky-200 rounded-xl mt-4 w-[50%] h-48 self-center">
        {doctor.image ? (
          <img
            src={doctor.image}
            alt={doctor.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <Profile className='w-full h-full bg-transparent' textClassname='text-5xl'/>
        )}
      </div>
      {/* name */}
      <h2 className="text-lg md:text-xl lg:text-2xl font-FigtreeRegular text-ui_blue text-center">
        {formatName(doctor.name)}
      </h2>
      <p className="text-lg font-FigtreeRegular text-ui_blue/80 text-center mb-4">
        {doctor.specialization.label}
      </p>
      {/* Doctor Info */}
      <div className="py-4 flex flex-col border-2 rounded-2xl">
        <Text className="text-lg text-ui_blue self-center font-FigtreeBold">
          {'Designation : '}
          {formatName(doctor.designation)}
        </Text>
        <Text className="text-lg text-ui_blue self-center font-FigtreeBold">
          {'Education : '}
          {formatName(doctor.education)}
        </Text>

        <div className="flex justify-around items-center mt-3">
          <div className="flex flex-col items-center">
            <Text className="text-xl font-FigtreeBold text-ui_blue">
              {doctor.experience}
            </Text>
            <Text className="text-xl text-ui_blue font-FigtreeRegular">
              Years
            </Text>
          </div>

          <div className="flex flex-col items-center">
            <Text className="text-xl inline-flex gap-1 items-center font-FigtreeBold text-ui_blue">
              {doctor.rating}/5
            </Text>
            <Text className="text-xl text-ui_blue font-FigtreeRegular">
              Ratings
            </Text>
          </div>

          <div className="flex flex-col items-center">
            <Text className="text-xl font-bold text-ui_blue">
              ₹ {doctor.price}
            </Text>
            <Text className="text-xl text-ui_blue font-FigtreeRegular">
              Charges
            </Text>
          </div>
        </div>
      </div>
    </Modal>
  );
};
